'use client';
import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { MessageSquare, ShieldCheck } from 'lucide-react';

// Backend integration point: GET /api/employers/me/messages/preview
const threads = [
{
  id: 'thread-001',
  workerName: 'Thandi M.',
  workerVetted: true,
  workerPhoto: "https://img.rocket.new/generatedImages/rocket_gen_img_12bbf7f12-1772647621786.png",
  workerPhotoAlt: 'Smiling woman with natural hair',
  lastMessage: 'I will be there at 07:00 sharp. Looking forward to meeting your mother.',
  time: '09:14',
  unread: 1,
  today: true
},
{
  id: 'thread-002',
  workerName: 'Lerato N.',
  workerVetted: true,
  workerPhoto: "https://images.unsplash.com/photo-1631253601025-27c774909b9a",
  workerPhotoAlt: 'Young woman with braided hair smiling warmly',
  lastMessage: 'Could we move the start time to 08:00? I have a school run first.',
  time: 'Yesterday',
  unread: 2,
  today: false
},
{
  id: 'thread-003',
  workerName: 'Sipho K.',
  workerVetted: true,
  workerPhoto: "https://images.unsplash.com/photo-1601239156071-15ec4c7beff2",
  workerPhotoAlt: 'Young man with short hair smiling in outdoor setting',
  lastMessage: 'Happy to do the house sit. The dogs are no problem at all.',
  time: '2 May',
  unread: 0,
  today: false
}];


export default function EmployerMessagesPreview() {
  return (
    <div className="card overflow-hidden h-full flex flex-col">
      <div className="px-5 pt-5 pb-4 border-b border-border flex items-center justify-between">
        <h3 className="font-bold" style={{ color: 'var(--navy)' }}>Messages</h3>
        <span className="text-xs px-2 py-1 rounded-full font-bold" style={{ background: 'var(--orange-pale)', color: 'var(--primary)' }}>
          3 unread
        </span>
      </div>
      <div className="flex-1 divide-y divide-border overflow-y-auto">
        {threads?.map((thread) =>
        <Link
          key={thread?.id}
          href="/employer-dashboard"
          className="flex items-start gap-3 px-5 py-4 hover:bg-muted/30 transition-colors block">
          
            <div className="relative flex-shrink-0">
              <AppImage
              src={thread?.workerPhoto}
              alt={thread?.workerPhotoAlt}
              width={44}
              height={44}
              className="w-11 h-11 rounded-full object-cover" />
            
              {thread?.workerVetted &&
            <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full flex items-center justify-center" style={{ background: 'var(--vetted-color)' }}>
                  <ShieldCheck size={9} color="white" />
                </div>
            }
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-sm font-bold" style={{ color: 'var(--navy)' }}>{thread?.workerName}</span>
                <span className="text-xs flex-shrink-0" style={{ color: 'var(--muted-foreground)' }}>{thread?.time}</span>
              </div>
              <p className="text-xs truncate" style={{ color: thread?.unread > 0 ? 'var(--foreground)' : 'var(--muted-foreground)', fontWeight: thread?.unread > 0 ? '600' : '400' }}>
                {thread?.lastMessage}
              </p>
            </div>

            {thread?.unread > 0 &&
          <span className="w-5 h-5 rounded-full text-xs font-bold text-white flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'var(--primary)' }}>
                {thread?.unread}
              </span>
          }
          </Link>
        )}
      </div>
      <div className="px-5 py-4 border-t border-border">
        <Link
          href="/messages"
          className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-sm font-semibold border border-border hover:bg-muted transition-colors" style={{ color: 'var(--navy)' }}>
          <MessageSquare size={15} />
          Open all messages
        </Link>
      </div>
    </div>);

}